import { render, staticRenderFns } from "./ExternalScriptAdapter.vue?vue&type=template&id=38ef90b6&scoped=true&"
import script from "./ExternalScriptAdapter.vue?vue&type=script&lang=ts&"
export * from "./ExternalScriptAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef90b6",
  null
  
)

export default component.exports